import React from 'react';


function Footer(props) {


  return(
    <>
    <footer>
    <section className="footer bg-dark text-white py-4">
    <div className="footer-area">
    
             <div className="footer-bootom container">
                 <div className="row">
                     <div className="col-12">
                         <p className="float-left">&copy;Copyright &copy;All rights reserved</p>
                         <p className="float-right"><small> This site by Er.fauzan</small></p>
                     </div>
                 </div>
             </div>
      
      </div>
    </section>  
    </footer>
    </>
  
  );

}

export default Footer;
